import {
  Timer,
  Repeat,
  Zap,
  Target,
  Brain,
  type LucideIcon,
} from 'lucide-react';

export type FormQuestion = {
  id: number;
  icon: LucideIcon;
  title: string;
  question: string;
  options: { a: string; b: string; c: string };
  correct: 'a' | 'b' | 'c';
};

export const FORM_QUESTIONS: FormQuestion[] = [
  {
    id: 1,
    icon: Timer,
    title: 'Disponibilidad real',
    question: '\u00BFCu\u00E1ntas horas reales puedes dedicar al d\u00EDa?',
    options: {
      a: 'Menos de 2 horas',
      b: 'Entre 2 y 3 horas',
      c: '4 horas o m\u00E1s',
    },
    correct: 'c',
  },
  {
    id: 2,
    icon: Repeat,
    title: 'Tolerancia a repetici\u00F3n',
    question:
      '\u00BFC\u00F3mo te sientes haciendo una tarea repetitiva durante varias horas?',
    options: {
      a: 'Me cuesta mucho, me aburro r\u00E1pido',
      b: 'Depende del d\u00EDa',
      c: 'Si tiene objetivo claro, entro en ritmo',
    },
    correct: 'c',
  },
  {
    id: 3,
    icon: Zap,
    title: 'Velocidad de decisi\u00F3n',
    question: 'Cuando tienes que decidir r\u00E1pido si algo encaja o no:',
    options: {
      a: 'Dudo bastante antes de decidir',
      b: 'A veces dudo, a veces decido r\u00E1pido',
      c: 'Decido r\u00E1pido y sigo',
    },
    correct: 'c',
  },
  {
    id: 4,
    icon: Target,
    title: 'Compromiso con objetivo',
    question: 'Si te marcas un objetivo diario exigente:',
    options: {
      a: 'Si no me sale, lo dejo para otro d\u00EDa',
      b: 'Lo intento, pero depende de c\u00F3mo vaya el d\u00EDa',
      c: 'Lo cumplo aunque tenga que apretar',
    },
    correct: 'c',
  },
  {
    id: 5,
    icon: Brain,
    title: 'Reacci\u00F3n ante dificultad',
    question: 'Si los primeros d\u00EDas no consigues resultados:',
    options: {
      a: 'Pienso que esto no es para m\u00ED',
      b: 'Bajo el ritmo',
      c: 'Ajusto c\u00F3mo lo hago hasta que funciona',
    },
    correct: 'c',
  },
];

export const COMMITMENT_QUESTION = {
  title: 'PRIMERA PRUEBA SUPERADA',
  intro: 'Antes de unirte al juego...',
  question:
    'Este sistema no es para probar. Es para ejecutar. \u00BFEst\u00E1s dentro o no?',
  options: {
    a: 'Quiero probar',
    b: 'Depende',
    c: 'Estoy dentro a jugar con todo',
  },
  correct: 'c' as const,
};
